import * as React from 'react';
import {
    Box,
    Grid,
    Button,
    TextField,
    Snackbar,
    Alert,
    Typography,
    FormControl,
    MenuItem,
    Card,
    CardContent,
    FormControlLabel,
    Checkbox,
    FormHelperText,
    Radio,
    RadioGroup,
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Modal
} from '@mui/material';

import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const InstituteDetailsComp = (props) => {

    return (
        <Box>

            {/* HEADER */}
            <Box mb={3}>
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        color: '#042740'
                    }}
                >
                    Institute Details
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    Manage institute onboarding and partnership information
                </Typography>
            </Box>

            {/* BASIC DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Basic Information
                    </Typography>

                    <Grid container spacing={2}>

                        {/* Institute Name */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Institute Name*"
                                value={props.LeadFormData.txtInstituteName || ''}
                                error={
                                    props.LeadFormData.txtInstituteNameErr ? true : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteName')
                                }
                            />
                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteNameErr}
                            </FormHelperText>
                        </Grid>

                        {/* Institute Type */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Institute Type*"
                                value={props.LeadFormData.ddlInstituteType || ''}
                                error={
                                    props.LeadFormData.ddlInstituteTypeErr ? true : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlInstituteType')
                                }
                            >
                                <MenuItem value={'Language Institute'}>
                                    Language Institute
                                </MenuItem>

                                <MenuItem value={'Immigration Company'}>
                                    Immigration Company
                                </MenuItem>

                                <MenuItem value={'Freelance Mobiliser'}>
                                    Freelance Mobiliser
                                </MenuItem>

                                <MenuItem value={'Freelance Trainer'}>
                                    Freelance Trainer
                                </MenuItem>
                            </TextField>

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlInstituteTypeErr}
                            </FormHelperText>
                        </Grid>

                        {/* Country */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Country*"
                                value={props.LeadFormData.txtInstituteCountry || ''}
                                error={
                                    props.LeadFormData.txtInstituteCountryErr ? true : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteCountry')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteCountryErr}
                            </FormHelperText>
                        </Grid>

                        {/* City */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="City*"
                                value={props.LeadFormData.txtInstituteCity || ''}
                                error={
                                    props.LeadFormData.txtInstituteCityErr ? true : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteCity')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteCityErr}
                            </FormHelperText>
                        </Grid>

                        {/* Location */}
                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Location*"
                                value={props.LeadFormData.txtInstituteLocation || ''}
                                error={
                                    props.LeadFormData.txtInstituteLocationErr ? true : false
                                }
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteLocation')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteLocationErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* POC DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Institute POC Details
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="POC Name*"
                                value={props.LeadFormData.txtInstituteUprnPocName || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteUprnPocName')
                                }
                                error={!!props.LeadFormData.txtInstituteUprnPocNameErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteUprnPocNameErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="POC Mobile*"
                                value={props.LeadFormData.txtInstituteUprnPocMobile || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteUprnPocMobile')
                                }
                                error={!!props.LeadFormData.txtInstituteUprnPocMobileErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteUprnPocMobileErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="POC Email*"
                                value={props.LeadFormData.txtInstituteUprnPocEmail || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteUprnPocEmail')
                                }
                                error={!!props.LeadFormData.txtInstituteUprnPocEmailErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteUprnPocEmailErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card >
            {/* POC DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        UPRN POC Details
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                select
                                label={'Select Department*'}
                                value={props.LeadFormData.ddlLeadDepartment || ''}
                                error={props.LeadFormData.ddlLeadDepartmentErr == undefined || props.LeadFormData.ddlLeadDepartmentErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                            >
                                {
                                    props.mystate.profileListData.length > 0 ?
                                        props.mystate.profileListData.map((item) =>
                                            <MenuItem value={item.profile_name}>{item.profile_name}</MenuItem>

                                        )
                                        :
                                        null
                                }
                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadDepartmentErr}</FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                select
                                value={props.LeadFormData.ddlLeadOwner || ''}
                                label="Select Owner*"
                                error={props.LeadFormData.ddlLeadOwnerErr == undefined || props.LeadFormData.ddlLeadOwnerErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                            >
                                {
                                    props.mystate.userListData.length > 0 ?

                                        props.mystate.userListData.map((item) =>
                                            item.user_profile_name === props.LeadFormData.ddlLeadDepartment ?
                                                <MenuItem value={item.user_name}>{item.user_name}</MenuItem>
                                                :
                                                null
                                        )
                                        :
                                        null
                                }
                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.LeadFormData.ddlLeadOwnerErr}</FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                disabled
                                label="UPRN POC"
                                value={props.LeadFormData.txtInstituteUprnPoc || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteUprnPoc')
                                }
                            />
                        </Grid>


                    </Grid>

                </CardContent>
            </Card >

            {/* LANGUAGE DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Language & Training Details
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Core Languages* (Seperate by ,)"
                                value={props.LeadFormData.txtInstituteCoreLanguages || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtInstituteCoreLanguages')
                                }
                                error={!!props.LeadFormData.txtInstituteCoreLanguagesErr}
                            />
                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtInstituteCoreLanguagesErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Language Fees*"
                                value={props.LeadFormData.txtLanguageFees || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtLanguageFees')
                                }
                                error={!!props.LeadFormData.txtLanguageFeesErr}
                            />
                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtLanguageFeesErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Trainer Level*"
                                value={props.LeadFormData.txtTrainerLevel || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtTrainerLevel')
                                }
                                error={!!props.LeadFormData.txtTrainerLevelErr}
                            >
                                <MenuItem value={'B1'}>B1</MenuItem>
                                <MenuItem value={'B2'}>B2</MenuItem>
                                <MenuItem value={'C1'}>C1</MenuItem>
                                <MenuItem value={'C2'}>C2</MenuItem>
                            </TextField>

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtTrainerLevelErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Mode Of Training*"
                                value={props.LeadFormData.ddlModeOfTraining || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlModeOfTraining')
                                }
                                error={!!props.LeadFormData.ddlModeOfTrainingErr}
                            >
                                <MenuItem value={'Online'}>Online</MenuItem>
                                <MenuItem value={'Offline'}>Offline</MenuItem>
                                <MenuItem value={'Hybrid'}>Hybrid</MenuItem>
                            </TextField>

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlModeOfTrainingErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label="Interview Prep By*"
                                    value={props.LeadFormData.txtInterviewPrepBy || ''}
                                    onChange={(e) =>
                                        props.HandleInputs(e, 'txtInterviewPrepBy')
                                    }
                                    error={!!props.LeadFormData.txtInterviewPrepByErr}
                                >
                                    <MenuItem value={'UPRN'}>
                                        UPRN
                                    </MenuItem>

                                    <MenuItem value={'Institute'}>
                                        Institute
                                    </MenuItem>
                                </TextField>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.txtInterviewPrepByErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label="Exam Provider*"
                                    value={props.LeadFormData.txtExamProvider || ''}
                                    onChange={(e) =>
                                        props.HandleInputs(e, 'txtExamProvider')
                                    }
                                    error={!!props.LeadFormData.txtExamProviderErr}
                                >
                                    <MenuItem value={'Telc'}>
                                        Telc
                                    </MenuItem>

                                    <MenuItem value={'Goethe'}>
                                        Goethe
                                    </MenuItem>

                                    <MenuItem value={'OSD'}>
                                        OSD
                                    </MenuItem>
                                </TextField>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.txtExamProviderErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Exam Type*"
                                value={props.LeadFormData.txtExamType || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtExamType')
                                }
                                error={!!props.LeadFormData.txtExamTypeErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtExamTypeErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="B1 Batch Graduating Month"
                                value={props.LeadFormData.txtB1BatchGraduatingMonth || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtB1BatchGraduatingMonth')
                                }
                                error={!!props.LeadFormData.txtB1BatchGraduatingMonthErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtB1BatchGraduatingMonthErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="B2 Batch Graduating Month"
                                value={props.LeadFormData.txtB2BatchGraduatingMonth || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtB2BatchGraduatingMonth')
                                }
                                error={!!props.LeadFormData.txtB2BatchGraduatingMonthErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtB2BatchGraduatingMonthErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Placement Doc Fees"
                                value={props.LeadFormData.txtPlacementDocFees || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtPlacementDocFees')
                                }
                                error={!!props.LeadFormData.txtPlacementDocFeesErr}
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtPlacementDocFeesErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl
                                component="fieldset"
                                error={!!props.LeadFormData.chkNeedFinishingSchoolErr}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 1,
                                        color: '#555',
                                        fontWeight: 500
                                    }}
                                >
                                    Need Finishing School
                                </Typography>

                                <RadioGroup
                                    row
                                    value={
                                        props.LeadFormData.chkNeedFinishingSchool === true
                                            ? 'Yes'
                                            : props.LeadFormData.chkNeedFinishingSchool === false
                                                ? 'No'
                                                : ''
                                    }
                                    onChange={(e) =>
                                        props.HandleInputs(
                                            {
                                                target: {
                                                    value: e.target.value === 'Yes'
                                                }
                                            },
                                            'chkNeedFinishingSchool'
                                        )
                                    }
                                >
                                    <FormControlLabel
                                        value="Yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />

                                    <FormControlLabel
                                        value="No"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </RadioGroup>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.chkNeedFinishingSchoolErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl
                                component="fieldset"
                                error={!!props.LeadFormData.chkPlacementAvailableErr}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 1,
                                        color: '#555',
                                        fontWeight: 500
                                    }}
                                >
                                    Placement Available
                                </Typography>

                                <RadioGroup
                                    row
                                    value={
                                        props.LeadFormData.chkPlacementAvailable === true
                                            ? 'Yes'
                                            : props.LeadFormData.chkPlacementAvailable === false
                                                ? 'No'
                                                : ''
                                    }
                                    onChange={(e) =>
                                        props.HandleInputs(
                                            {
                                                target: {
                                                    value: e.target.value === 'Yes'
                                                }
                                            },
                                            'chkPlacementAvailable'
                                        )
                                    }
                                >
                                    <FormControlLabel
                                        value="Yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />

                                    <FormControlLabel
                                        value="No"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </RadioGroup>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.chkPlacementAvailableErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl
                                component="fieldset"
                                error={!!props.LeadFormData.chkRaAvailableErr}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 1,
                                        color: '#555',
                                        fontWeight: 500
                                    }}
                                >
                                    RA Available
                                </Typography>

                                <RadioGroup
                                    row
                                    value={
                                        props.LeadFormData.chkRaAvailable === true
                                            ? 'Yes'
                                            : props.LeadFormData.chkRaAvailable === false
                                                ? 'No'
                                                : ''
                                    }
                                    onChange={(e) =>
                                        props.HandleInputs(
                                            {
                                                target: {
                                                    value: e.target.value === 'Yes'
                                                }
                                            },
                                            'chkRaAvailable'
                                        )
                                    }
                                >
                                    <FormControlLabel
                                        value="Yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />

                                    <FormControlLabel
                                        value="No"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </RadioGroup>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.chkRaAvailableErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <FormControl
                                component="fieldset"
                                error={!!props.LeadFormData.chkCareHomeJobsErr}
                            >
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 1,
                                        color: '#555',
                                        fontWeight: 500
                                    }}
                                >
                                    Are they ok with Care Home jobs?
                                </Typography>

                                <RadioGroup
                                    row
                                    value={
                                        props.LeadFormData.chkCareHomeJobs === true
                                            ? 'Yes'
                                            : props.LeadFormData.chkCareHomeJobs === false
                                                ? 'No'
                                                : ''
                                    }
                                    onChange={(e) =>
                                        props.HandleInputs(
                                            {
                                                target: {
                                                    value: e.target.value === 'Yes'
                                                }
                                            },
                                            'chkCareHomeJobs'
                                        )
                                    }
                                >
                                    <FormControlLabel
                                        value="Yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />

                                    <FormControlLabel
                                        value="No"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </RadioGroup>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.chkCareHomeJobsErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* STUDENT PIPELINE */}
            < Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Student Pipeline
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Nurses A1"
                                value={props.LeadFormData.txtNursesA1 || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtNursesA1')
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Nurses A2"
                                value={props.LeadFormData.txtNursesA2 || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtNursesA2')
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Nurses B1"
                                value={props.LeadFormData.txtNursesB1 || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtNursesB1')
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                label="Nurses B2"
                                value={props.LeadFormData.txtNursesB2 || ''}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtNursesB2')
                                }
                            />
                        </Grid>

                    </Grid>

                </CardContent>
            </Card >

            {/* BUSINESS DETAILS */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Business Details
                    </Typography>

                    <Grid container spacing={2}>

                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    fullWidth
                                    label="Agreement Status*"
                                    value={props.LeadFormData.txtAgreementStatus || ''}
                                    error={!!props.LeadFormData.txtAgreementStatusErr}
                                    onChange={(e) =>
                                        props.HandleInputs(e, 'txtAgreementStatus')
                                    }
                                >
                                    <MenuItem value={'Pending'}>
                                        Pending
                                    </MenuItem>

                                    <MenuItem value={'Signed'}>
                                        Signed
                                    </MenuItem>
                                </TextField>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.txtAgreementStatusErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>



                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Relationship Owner*"
                                value={props.LeadFormData.txtRelationshipOwner || ''}
                                error={!!props.LeadFormData.txtRelationshipOwnerErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtRelationshipOwner')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtRelationshipOwnerErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Deal Value Per Month"
                                value={props.LeadFormData.txtDealValuePerMonth || ''}
                                error={!!props.LeadFormData.txtDealValuePerMonthErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtDealValuePerMonth')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtDealValuePerMonthErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Talent Pool Size Monthly"
                                value={props.LeadFormData.txtTalentPoolSizeMonthly || ''}
                                error={!!props.LeadFormData.txtTalentPoolSizeMonthlyErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtTalentPoolSizeMonthly')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtTalentPoolSizeMonthlyErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Student Tech Level"
                                value={props.LeadFormData.txtStudentTechLevel || ''}
                                error={!!props.LeadFormData.txtStudentTechLevelErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtStudentTechLevel')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtStudentTechLevelErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Total CVs Shared"
                                value={props.LeadFormData.txtTotalCvsShared || ''}
                                error={!!props.LeadFormData.txtTotalCvsSharedErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtTotalCvsShared')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtTotalCvsSharedErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Total Hired"
                                value={props.LeadFormData.txtTotalHired || ''}
                                error={!!props.LeadFormData.txtTotalHiredErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtTotalHired')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtTotalHiredErr}
                            </FormHelperText>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Win Rate Percentage"
                                value={props.LeadFormData.txtWinRatePercentage || ''}
                                error={!!props.LeadFormData.txtWinRatePercentageErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'txtWinRatePercentage')
                                }
                            />

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.txtWinRatePercentageErr}
                            </FormHelperText>
                        </Grid>

                    </Grid>

                </CardContent>
            </Card>

            {/* Acquisition Details */}
            <Card sx={{ mb: 3, borderRadius: 3 }}>
                <CardContent>

                    <Typography
                        variant="h6"
                        sx={{
                            mb: 3,
                            color: '#042740',
                            fontWeight: 600
                        }}
                    >
                        Acquisition Details
                    </Typography>

                    <Grid container spacing={2}>


                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    fullWidth
                                    label="Lead Source*"
                                    value={props.LeadFormData.txtLeadSource || ''}
                                    error={!!props.LeadFormData.txtLeadSourceErr}
                                    onChange={(e) =>
                                        props.HandleInputs(e, 'txtLeadSource')
                                    }
                                >
                                    <MenuItem value={'Social Media'}>
                                        Social Media
                                    </MenuItem>

                                    <MenuItem value={'Employee Referral'}>
                                        Employee Referral
                                    </MenuItem>

                                    <MenuItem value={'External Referral'}>
                                        External Referral
                                    </MenuItem>

                                    <MenuItem value={'Inbound'}>
                                        Inbound
                                    </MenuItem>
                                </TextField>

                                <FormHelperText style={{ color: '#d32f2f' }}>
                                    {props.LeadFormData.txtLeadSourceErr}
                                </FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                select
                                fullWidth
                                label="Lead Stage*"
                                value={props.LeadFormData.ddlLeadStage || ''}
                                error={!!props.LeadFormData.ddlLeadStageErr}
                                onChange={(e) =>
                                    props.HandleInputs(e, 'ddlLeadStage')
                                }
                            >
                                <MenuItem value={'UnCalled'}>
                                    UnCalled
                                </MenuItem>
                                <MenuItem value={'RNR'}>
                                    RNR
                                </MenuItem>
                                <MenuItem value={'Call Back'}>
                                    Call Back
                                </MenuItem>
                                <MenuItem value={'Active'}>
                                    Active
                                </MenuItem>
                                <MenuItem value={'Onboarding'}>
                                    Onboarding
                                </MenuItem>
                                <MenuItem value={'Inactive'}>
                                    Inactive
                                </MenuItem>

                            </TextField>

                            <FormHelperText style={{ color: '#d32f2f' }}>
                                {props.LeadFormData.ddlLeadStageErr}
                            </FormHelperText>
                        </Grid>




                        {
                            props.LeadFormData.ddlLeadStage === 'Call Back' && (
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        type="datetime-local"
                                        label="Call Back Date & Time"
                                        InputLabelProps={{ shrink: true }}
                                        value={props.LeadFormData.txtCallBackDateTime || ''}
                                        onChange={(e) =>
                                            props.HandleInputs(e, 'txtCallBackDateTime')
                                        }
                                        inputProps={{
                                            min: new Date().toISOString().slice(0, 16)
                                        }}
                                        error={!!props.LeadFormData.txtCallBackDateTimeErr}
                                    />

                                    <FormHelperText style={{ color: '#d32f2f' }}>
                                        {props.LeadFormData.txtCallBackDateTimeErr}
                                    </FormHelperText>
                                </Grid>
                            )
                        }


                        {
                            props.LeadFormData.ddlLeadStage === 'Onboarding' && (
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        fullWidth
                                        type="datetime-local"
                                        label="Onboarding Date & Time"
                                        InputLabelProps={{ shrink: true }}
                                        value={props.LeadFormData.txtOnboardingDateTime || ''}
                                        onChange={(e) =>
                                            props.HandleInputs(e, 'txtOnboardingDateTime')
                                        }
                                        inputProps={{
                                            min: new Date().toISOString().slice(0, 16)
                                        }}
                                        error={!!props.LeadFormData.txtOnboardingDateTimeErr}
                                    />

                                    <FormHelperText style={{ color: '#d32f2f' }}>
                                        {props.LeadFormData.txtOnboardingDateTimeErr}
                                    </FormHelperText>
                                </Grid>
                            )
                        }


                        {

                            (
                                props.mystate.mode === 'edit' &&
                                props.mystate.leadDetails?.length > 0 &&
                                props.LeadFormData.ddlLeadStage !== props.mystate.leadDetails?.[0]?.lead_stage
                            ) ?
                                <Grid item xs={12} md={4}>
                                    <TextField multiline rows={4} className="text-input" id="txtInteractionDesc" name='txtInteractionDesc' error={props.LeadFormData.txtInteractionDescErr == undefined || props.LeadFormData.txtInteractionDescErr == '' ? false : true} helperText={props.LeadFormData.txtInteractionDescErr} onChange={(e) => props.HandleInputs(e, 'txtInteractionDesc')} value={props.LeadFormData.txtInteractionDesc || ''} label="Enter Description*" variant="outlined" />
                                    {/* <FormHelperText style={{ color: '#d32f2f' }}>
                                        {props.LeadFormData.txtInteractionDescErr}
                                    </FormHelperText> */}
                                </Grid>
                                :
                                null

                        }



                    </Grid>

                </CardContent>
            </Card >

            {
                props.mystate.mode === 'edit' ?
                    <Card sx={{ mb: 3, borderRadius: 3 }}>
                        <CardContent>

                            <Grid container>
                                <Grid xs={6} md={6} mt={5} id="description">
                                    <Box p={1}>
                                        <Typography className='grey-theme-btn' fontWeight={'bold'} variant="h6" component="h6">
                                            Comments
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid xs={6} md={6} mt={5}>
                                    {
                                        props.mystate.userData.profile !== 'Marketing' ?
                                            <Box p={1} textAlign={'right'}>
                                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Add New</Button>
                                            </Box>
                                            :
                                            null
                                    }
                                </Grid>

                                <Grid xs={12} md={12}>
                                    <Box p={1}>
                                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                            <TableContainer sx={{ maxHeight: '200px' }}>
                                                <Table stickyHeader aria-label="sticky table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                key={'SrNo'}
                                                                align={'left'}
                                                                width={50}
                                                                className='table-head-cell'
                                                            >
                                                                {'SrNo'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Added On'}
                                                                align={'left'}
                                                                width={100}
                                                                className='table-head-cell'
                                                            >
                                                                {'Added On'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Added By'}
                                                                align={'left'}
                                                                width={100}
                                                                className='table-head-cell'
                                                            >
                                                                {'Added By'}
                                                            </TableCell>
                                                            <TableCell
                                                                key={'Comment'}
                                                                align={'left'}
                                                                width={150}
                                                                className='table-head-cell'
                                                            >
                                                                {'Comment'}
                                                            </TableCell>



                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.mystate.leadDetails != undefined && props.mystate.leadDetails.length > 0 && props.mystate.leadDetails[0].comment_array && props.mystate.leadDetails[0].comment_array.length > 0 ?
                                                            props.mystate.leadDetails[0].comment_array.map((item, i) => (
                                                                <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                                                                    <TableCell key={i + 1} align={'left'}>
                                                                        {i + 1}
                                                                    </TableCell>
                                                                    <TableCell key={item.Date + i} align={'left'}>
                                                                        {item.Date}
                                                                    </TableCell>
                                                                    <TableCell key={item["Added By"] + i} align={'left'}>
                                                                        {item["Added By"]} <br></br> <strong>{item["Added By Profile"]}</strong>
                                                                    </TableCell>
                                                                    <TableCell key={item.Comment + i} align={'left'}>
                                                                        <span>{item.Comment}</span>
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))
                                                            : ''
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card >
                    :
                    null
            }

            <Modal
                open={props.mystate.openDescriptionBox}
                onClose={() => props.ToggleDescriptionBox()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Comment
                    </Typography>
                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtLeadComment" name='txtLeadComment' error={props.LeadFormData.txtLeadCommentErr == undefined || props.LeadFormData.txtLeadCommentErr == '' ? false : true} helperText={props.LeadFormData.txtLeadCommentErr} onChange={(e) => props.HandleInputs(e, 'txtLeadComment')} value={props.LeadFormData.txtLeadComment || ''} label="Enter Your Comment" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid sx={6}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddDescription()}>Add</Button>
                            </Grid>
                            <Grid sx={6} ml={2}>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.ToggleDescriptionBox()}>Cancel</Button>
                            </Grid>
                        </Grid>
                    </Box>

                </Box>
            </Modal>

            {/* SAVE BUTTON */}
            < Grid container >
                <Grid item xs={12}>
                    <Box textAlign={'center'} m={3}>

                        {
                            props.mystate.mode === 'add' ?

                                props.LeadFormData.addUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Save Institute
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateLead()}
                                    >
                                        Save Institute
                                    </Button>

                                :

                                props.LeadFormData.editUser === true ?

                                    <LoadingButton
                                        loading
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                    >
                                        Update Institute
                                    </LoadingButton>

                                    :

                                    <Button
                                        variant="contained"
                                        className='grey-theme-btn'
                                        onClick={() => props.SaveOrUpdateLead()}
                                    >
                                        Update Institute
                                    </Button>
                        }

                    </Box>
                </Grid>
            </Grid >

            {/* ALERT */}
            < Snackbar
                open={props.mystate.showAlert}
                autoHideDuration={3000}
                onClose={() => {
                    props.HandleCloseAlertMsg(props.mystate.alertType);
                }}
            >
                <Alert
                    onClose={() => {
                        props.HandleCloseAlertMsg(props.mystate.alertType);
                    }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar >

        </Box >
    );
};